import { gql } from '@apollo/client';

// The community and block tags offered by the audit form's two selectors. Blocks come back in
// chronological order, communities alphabetically — the server sorts them, because block codes
// (`OCT2025`) sort alphabetically into the wrong order.
export const GET_AUDIT_TAG_OPTIONS = gql`
query AuditTagOptions {
  communities: auditTagOptions(group: "community") {
    id
    name
    code
  }
  blocks: auditTagOptions(group: "block") {
    id
    name
    code
  }
}`;

// Every audit recorded for one community, oldest block first.
export const GET_COURSE_DELIVERY_AUDITS = gql`
query CourseDeliveryAudits($communityTagId: Int!) {
  courseDeliveryAudits(communityTagId: $communityTagId) {
    period
    blockTagId
    confidence
    capacity
    connection
    contribution
    notes
  }
}`;
